import { z } from "zod";

export const EventStatusSchema = z.enum(["active", "archived"]);

export const E164PhoneSchema = z.string().regex(/^\+[1-9]\d{7,14}$/, "Phone must be E.164");

export const SafetyAlertRecipientSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1).max(80),
  phoneNumber: E164PhoneSchema,
  organisation: z.string().max(80).optional(),
  active: z.boolean().default(true),
});

export const EventSchema = z.object({
  eventId: z.string().describe("URL slug; document ID"),
  displayName: z.string().min(1).max(120).describe("Human-readable event name"),
  status: EventStatusSchema.default("active"),
  createdAt: z.date().describe("When the event was created"),
  safetyAlertRecipients: z.array(SafetyAlertRecipientSchema).default([]),
});

export type Event = z.infer<typeof EventSchema>;
export type EventStatus = z.infer<typeof EventStatusSchema>;
export type SafetyAlertRecipient = z.infer<typeof SafetyAlertRecipientSchema>;
